import React from 'react'

const PageFrequentlyAskedQuestions = ({ slice }) => {

    return (
        <section className="page-frequently-asked-questions">
            <div className="container">
                <h2>{slice.primary.header.text}</h2>
                <div className="page-faq-grid">
                    {slice.items.map((item, index) => (
                        <div className="faq-item">
                            <p className="faq-question">{item.question.text}</p>
                            <p className="faq-answer">{item.answer.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default PageFrequentlyAskedQuestions